import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Loader from "../loader/Loader";

const WastageReportModalDetails = ({ show, handleClose, wastageId }) => {

    const [WastageReportModalDetails, setWastageReportModalDetails] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchWastageReportModalDetails = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true);
            const response = await axios.get(`${config.API}/manager/wastagelogs/${wastageId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = response?.data;
            if (data.success === true) {
                setWastageReportModalDetails(data.wastagelog)

            } else {
                setWastageReportModalDetails([]);
            }

        } catch (err) {
            console.error("Error fetching operators:", err.message);
            setWastageReportModalDetails([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && wastageId) {
            fetchWastageReportModalDetails();
        }
    }, [show, wastageId]);

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
          {
            loading?(<Loader/>):(
                  <Modal.Body className="p-5">
                <h4 className="mb-4 fw-bold">Wastage Log Report</h4>

                {/* Material Information */}
                <div className="p-3 border rounded bg-light mb-4">
                    <h6 className="fw-semibold">Material Information</h6>
                    <Row className="mt-2">
                        <Col md={6}><strong>ID:</strong> {WastageReportModalDetails?.material_master?.material_code}</Col>
                        <Col md={6}><strong>Material:</strong> {WastageReportModalDetails?.material_master?.material_name}</Col>
                    </Row>
                    <Row>
                        <Col md={6}><strong>Expected Qty:</strong> {WastageReportModalDetails?.material_master?.quantity_in_stock} {WastageReportModalDetails?.material_master?.unit_of_measurement}</Col>
                        <Col md={6}><strong>Supplier:</strong> MetalCrop</Col>
                    </Row>
                </div>

                {/* NC Report */}
                <div className="p-3 border rounded bg-light mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <h6 className="fw-semibold mb-0">NC Report by Operator</h6> */}
                        <Button size="sm" variant="outline-secondary">View Full Report</Button>
                    </div>
                    {/* <p className="mb-3">Lorem ipsum dolor sit amet consectetur. Platea est.</p> */}

                    {/* Inspection Checklist */}
                    <h6 className="fw-semibold mb-2">Inspection Checklist</h6>
                    <Form>
                        <Form.Check label="Visual Inspection (No visible defects)" defaultChecked />
                        <Form.Check label="Dimensional Check (Meets specifications)" defaultChecked />
                        <Form.Check label="Quantity Check (Matches delivery note)" defaultChecked />
                        <Form.Check label="Packaging Condition (No damage)" defaultChecked />
                        <Form.Check label="Material Certificate (Provided and valid)" defaultChecked />
                    </Form>
                </div>

                <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                        <Form.Group className="mt-4">
                            <Row>
                                <Col md={2}>
                                    <Form.Label>Notes</Form.Label>
                                </Col>
                                <Col md={10}>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={WastageReportModalDetails?.reason || ""}
                                        readOnly
                                    />
                                </Col>

                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            )
          }

            <Modal.Footer className="border-0">
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WastageReportModalDetails;
